import { EtatPetiteAnnonce } from "../enums/etat-petite-annonce.enum";

export const getEtatPetiteAnnonce = (etat: EtatPetiteAnnonce) => {
  switch (etat) {
    case EtatPetiteAnnonce.AttentePaiement:
      return "En attente de paiement";
    case EtatPetiteAnnonce.Payee:
      return "Envoyée pour validation";
    case EtatPetiteAnnonce.Rejetee:
      return "Refusée";
    case EtatPetiteAnnonce.Remboursee:
      return "Remboursée";
    case EtatPetiteAnnonce.Validee:
      return "Acceptée";
    default:
      return "Inconnu";
  }
};

export const getCouleurPetiteAnnonce = (etat: EtatPetiteAnnonce) => {
  switch (etat) {
    case EtatPetiteAnnonce.AttentePaiement:
      return "border border-[#ead893] bg-[#fff6d8] text-[#725716]";
    case EtatPetiteAnnonce.Payee:
      return "border border-sky-200 bg-sky-50 text-sky-700";
    case EtatPetiteAnnonce.Rejetee:
      return "border border-red-200 bg-red-50 text-red-700";
    case EtatPetiteAnnonce.Remboursee:
      return "border border-violet-200 bg-violet-50 text-violet-700";
    case EtatPetiteAnnonce.Validee:
      return "border border-[#b8d2c3] bg-[#e4efe9] text-[#173f35]";
    default:
      return "border border-slate-200 bg-slate-100 text-slate-700";
  }
};
